// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__OsnlR","Content":"styles_Content__zc64w","Title":"styles_Title__a0X_y"};